import { HttpContextAlpha } from '@blufin/react-core';
import type { IHttpClient } from '@blufin/types';
import { useContext } from 'react';

/** Hook to access HttpClientSlice from components. */
export const useHttpClientBeta = (): IHttpClient => {
  const context = useContext(HttpContextAlpha);
  if (!context) throw new Error('useHttpClientBeta() must be used within <HttpProviderAlpha.Provider/>');
  return context;
};
